import React, { useEffect, useState } from "react";
import BookingCalendar from "./calendar";
import moment from "moment-timezone";
import { getTimezones } from "../../services/uidata";
import { getDateCount, getTimeSlotsByDate } from "../../services/client";
import { Link, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLoading } from "../../reducer/auth/auth";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { filterVisibleTimeZones } from "../../utils/helpers";
import { updateDetectedTimezone } from "../../services/profile";
import Select from "react-select";
import CancellationPolicy from "../admin/appointments/subcomponents/cancellationpolicypopup";
import TimeZonePopup from "../profile/timeZonePopup";
import TimeZoneCofirmPopup from "../profile/timeZoneConfirmPopup";
import CountryTimeZoneSelection from "../profile/countryTimeZoneSelection";
import { getTimeZoneFromCountry } from "../../services/auth";


export default function BookingPage({ openForm, setBookingDate, setBookingTime, setTimeZoneInfo, setsession_id,
    setsubsession_id, setTimeZoneName, setTimeZoneLocalName, setPrice,
    setDuration, setPaymentInfo, setCurrency, price,
    currency,
    timezoneData,
    setTimezoneData,countryData, setCountryData, setcountryName, timeZoneName, userCountryCode, setUserCountryCode, countryName,setPayItForward }) {
    const { t } = useTranslation("publicGuestBooking");
    const params = useParams();
    const dispatch = useDispatch();

    const [pageType, setPageType] = useState('');

    const [timezone, setTimezone] = useState("");
    const [timeZoneValue, setTimeZoneValue] = useState("");
    const [appointmentTyepList, setAppointmentTyepList] = useState([]);
    const [dateCount, setDateCount] = useState({});
    const [activeSessionId, setActiveSessionId] = useState("");
    const [isExtraServices, setExtraServices] = useState(0);
    const [activeSubSessionId, setActiveSubSessionId] = useState("");

    //
    const [slots, setSlots] = useState([]);
    const [slotsupdated, setSlotsUpdated] = useState(false);
    const [active, setActive] = useState(false);
    const [count, setCount] = useState(0);
    const [noSlotsFound, setnoSlotsFound] = useState(false);
    const [month_empty, setmonth_empty] = useState(false);
    const [tineZonDetected, settineZonDetected] = useState(false);
    const [cancellationPolicy, setCancellationPolicy] = useState('');
    const [paymentRequest, setPaymentRequest] = useState('');
    const [countryValue, setCountryValue] = useState("");
    const [showFirstStep, setShowFirstStep] = useState(true);
    const [CurrentDate, setCurrentDate] = useState(moment().format('hh:mm A'))
    const [disableTime, setDisableTime] = useState('');
    const [countrySpecifiedTimeZone, setCountrySpecifiedTimeZone] = useState([
    
        ]);
         const usTimeZones =
        ["(GMT-5:00) Eastern Standard Time - New York",
            "(GMT-5:00) Eastern Standard Time - East-Indiana",
            "(GMT-6:00) Central Standard Time - Chicago",
            "(GMT-9:00) Alaska Standard Time - Alaska",
            "(GMT-10:00) Hawaii Standard Time - Honolulu",
            "(GMT-11:00) Samoa Standard Time - Midway",
            "(GMT-06:00) Central Standard Time - Chicago",
            "(GMT-05:00) Eastern Standard Time - New_York"
        ]
    const canadaTimeZones = ["(GMT-3:30) Newfoundland Standard Time - Newfoundland",
        "(GMT-4:00) Atlantic Standard Time - Atlantic",
        "(GMT-5:00) Eastern Standard Time - New York",
        "(GMT-6:00) Central Standard Time - Saskatchewan",
        "(GMT-6:00) Central Standard Time - Chicago",
        "(GMT-06:00) Central Standard Time - Chicago",
    ]



    useEffect(() => {

        setTimezone(moment.tz.guess());
        dispatch(setLoading(true))
    }, []);
    useEffect(() => {
        console.log(timezone, "timezone 123")
        if (timezone !== "") {
            updateTimezones(timezone);
        }
    }, [timezone]);

    const onChangeSessionHandler = (e) => {
        setSlotsUpdated(false);
        setActive(false);

        let value = e.target.value;
        console.log(value)
        console.log(appointmentTyepList, "appointmentTyepList")
        let item = appointmentTyepList.filter(
            (info) => parseInt(info.subsession_id) === parseInt(value)
        );
        console.log(item, "appointmentTyepList")
        setPageType('selection');
        setActiveSubSessionId(item[0].subsession_id);
        setActiveSessionId(item[0].session_id);
        setExtraServices(
            item[0] && item[0].is_extra_service !== undefined && item[0].is_extra_service !== null
                ? item[0].is_extra_service
                : 0
            );
        //
        setsession_id(item[0].session_id);
        setPrice(item[0].amount);
        setDuration(item[0].duration);
        setCurrency(item[0].currency)
        setsubsession_id(item[0].subsession_id);

    };
    const changeTimeZoneHandler = (e) => {
        let id = e.target.value;
        console.log(id, "id");
        let info = timezoneData.filter((time) => {
            return time.id === parseInt(id);
        });
        console.log(timezoneData, "timezoneData")
        console.log(info, 'timezoneData info');
        setCurrentDate(moment().tz(info[0].name).format('hh:mm A'))
        settineZonDetected(false)
        setTimeZoneName(info[0].front_name);
        setTimeZoneLocalName(info[0].name)
        setTimeZoneValue(id);
        setTimeZoneInfo(id);
        setSlotsUpdated(false);
        setActive(false);
    };
    const updateTimezones = (timezone) => {
        console.log(timezone, "timezone")
        getTimezones()
            .then((data) => {
                let items = filterVisibleTimeZones(data.data.data)
                let item = data.data.data.filter((time) => time.name === timezone);
                if (item.length && item[0].status == 0) {
                    items.push(item[0])
                }
                // let info = data.data.data.filter((time) => {
                //     return time.name === timezone;
                // });



                // if (item.length && item[0].status === 1) {
                if (item.length) {
                    setTimeZoneName(item[0].front_name);
                    setTimeZoneLocalName(item[0].name)
                    setTimeZoneValue(item[0].id);
                    setTimeZoneInfo(item[0].id)

                    //   let body = {
                    //         timezone:moment.tz.guess(),
                    //         is_matched: 1
                    //       }
                    //       updateDetectedTimezone(body).then(()=>{}).catch(()=>{})

                }

                else {
                    // let body = {
                    //     timezone: moment.tz.guess(),
                    //     is_matched: 0
                    // }
                    // updateDetectedTimezone(body).then(() => { }).catch(() => { })
                    dispatch(setLoading(false))
                    settineZonDetected(true)
                }

                // }
                // else {
                //     let info = getNextMatchingTimezone(data.data.data, timezone);
                //     console.log(data.data.data, "data.data.data")

                //     setTimeZoneName(info.front_name);
                //     setTimeZoneLocalName(info.name)
                //     setTimeZoneValue(info.id);
                //     setTimeZoneInfo(info.id)
                // }
                setTimezoneData(items);
            })
            .catch((err) => console.log(err));
    };





    const getNextMatchingTimezone = (timezoneData, newtime) => {
        const array = timezoneData;
        const currentValue = newtime;

        const currentIndex = array.findIndex(obj => obj.name === currentValue);
        const nextMatchingIndex = array.findIndex((obj, index) => index > currentIndex && obj.status === 1);
        const nextMatchingObject = nextMatchingIndex !== -1 ? array[nextMatchingIndex] : null;

        return nextMatchingObject;

    }
    const getDatesCount = (dates) => {
        dispatch(setLoading(true))

        let body = {
            medium_id: params.id,
            startDate: dates.start,
            endDate: dates.end,
            timezone: timeZoneValue,
            session_id: activeSessionId,
            subsession_id: activeSubSessionId,
        };
        getDateCount(body)
            .then((data) => {

                dispatch(setLoading(false))
                if (data.data.status) {
                    setAppointmentTyepList(data.data.externalInfo.available_sessions);
                    setPaymentInfo(data.data.externalInfo.payment_methods);
                    setPayItForward(data.data.externalInfo.medium_pay_forward);
                    if(activeSessionId == 7 || activeSessionId == 8){
                        setPaymentRequest("Paid");
                    }
                    if(data.data.externalInfo.cancellation_policy && data.data.externalInfo.cancellation_policy !== null && data.data.externalInfo.cancellation_policy !== undefined && data.data.externalInfo.cancellation_policy !== ""){
                        setCancellationPolicy(data.data.externalInfo.cancellation_policy);
                    }
                    setmonth_empty(data.data.externalInfo.month_empty)
                    if (data.data.externalInfo.month_empty) {
                        // window.scrollTo({
                        //     left: 0,
                        //     top: 700,
                        //     behavior: "smooth",
                        // });
                    }
                    if (count === 0) {


                        // setsubsession_id(data.data.externalInfo.available_sessions[0].subsession_id);
                        // setsession_id(data.data.externalInfo.available_sessions[0].session_id);
                        // setPrice(data.data.externalInfo.available_sessions[0].price);
                        // setDuration(data.data.externalInfo.available_sessions[0].duration);
                    }
                    setCount(count + 1)
                    // setActiveSubSessionId(data.data.externalInfo[0].subsession_id);
                    // setActiveSessionId(data.data.externalInfo[0].session_id)
                    setDateCount(data.data.data);
                }
                else {
                    setmonth_empty(false)
                    toast.error(data.data.message, {
                        position: "top-center",
                    });
                }
            })
            .catch(() => { dispatch(setLoading(false)) });
    };

    const getTimeSlots = (date) => {
        dispatch(setLoading(true))
        setSlotsUpdated(false);
        setActive(false);
        setBookingDate(date);
        let body = {
            medium_id: params.id,
            date: date,
            timezone: timeZoneValue,
            session_id:
                activeSessionId !== ""
                    ? activeSessionId
                    : appointmentTyepList[0].session_id,
            subsession_id:
                activeSubSessionId !== ""
                    ? activeSubSessionId
                    : appointmentTyepList[0].subsession_id,
        };
        getTimeSlotsByDate(body)
            .then((data) => {

                dispatch(setLoading(false))
                if (data.data.status && !data.data.data.slots.length > 0) {
                    setnoSlotsFound(true);
                    window.scrollTo({
                        left: 0,
                        top: 700,
                        behavior: "smooth",
                    });

                    // window.loadModal("#noslotsfound", "open");
                    return;
                }
                else if (data.data.status) {
                    setnoSlotsFound(false);
                    setSlotsUpdated(true);
                    setActive(true);
                    console.log(data.data.data.slots, "data.data.data.slots");
                    window.scrollTo({
                        left: 0,
                        top: 700,
                        behavior: "smooth",
                    });
                    setSlots(
                        data.data.data.slots.map((value) => {
                            return { datetime: value, selectedStatus: false, status: false };
                        })
                    );
                }

                else {
                    toast.error(data.data.message, {
                        position: "top-center",
                    });
                }
            })
            .catch(() => { });
    };
    const openCalendar = () => {
        setPageType('calendar');
    }
    const handleBookingClick = () => {
        if(activeSessionId == 7 || activeSessionId == 8 || isExtraServices == 1){
        window.loadModal2("#ConfirmCancellationPolicy", "show");
        }else{
            openForm();
        }
        //openForm();
    };
    const cancelRequest = () => {
    window.loadModal2("#ConfirmCancellationPolicy", "hide");
  };
  const confirmRequest = () => {
    window.loadModal2("#ConfirmCancellationPolicy", "hide");
    openForm();
  };
  const confirmRequestNew = () => {
    window.loadModal2("#ConfirmCancellationPolicy", "hide");
     window.loadModal2("#TimeZoneCofirmPopup", "hide");
      setShowFirstStep(false);  
   // openForm();
  };
 const handleNext = () => {
    console.log("timeZoneValue", timeZoneValue);
    console.log("countryValue", countryValue);
 let info = countryData.filter((time) => {
            return time.id === parseInt(countryValue);
        });
        let infoOne = timezoneData.filter((time) => {
            return time.id === parseInt(timeZoneValue);
        });
         let newTimeZone = infoOne[0].name;
        console.log(infoOne[0].front_name, "country info");
         
        
        if (timeZoneValue && countryValue) {
        if (newTimeZone == "US/Arizona") {
            setDisableTime(newTimeZone)
            window.loadModal2('#TimeZoneCofirmPopup', 'show');
         
            return;
        }
        // if (newTimeZone === "US/Mountain" || newTimeZone === "America/Los_Angeles") {
        //     setTemporaryStorage(body);
        //     const check = phone.slice(0, 4);
        //     console.log(check, "check")
        //     let array = [1623, 1480, 1520, 1867]
        //     if (array.includes(parseInt(check))) {
        //         setDisableTime('US/Arizona')
        //         window.loadModal2('#TimeZoneCofirmPopup', 'show');
        //         return;
        //     } else {

        //         window.loadModal2('#TimeZonePopup', 'show');
        //         return;
        //     }

        // }

        if (info[0].country_name == "United States" && !usTimeZones.includes(infoOne[0].front_name)) {
            window.loadModal2("#CountryTimeZoneSelection", "show");
           
            getTimeZoneFromCountry(info[0].country_code)
                .then((data) => {
                    if (data.data.status) {
                        setCountrySpecifiedTimeZone(data.data.data);
                    }
                })
                .catch(() => { });
            return;
        }
        if (info[0].country_name == "Canada" && !canadaTimeZones.includes(infoOne[0].front_name)) {
            window.loadModal2("#CountryTimeZoneSelection", "show");
           
            getTimeZoneFromCountry(info[0].country_code)
                .then((data) => {
                    if (data.data.status) {
                        setCountrySpecifiedTimeZone(data.data.data);
                    }
                })
                .catch(() => { });
            return;
        }
       
  
        setShowFirstStep(false);   // hide first, show second step
    } else {
        toast.error(t("bookingPage.selectBothToast"), {
                            position: "top-center",
                        });
    }
};
 const changeCountry = (e) => {
        let id = e.target.value;
        console.log(id, "id");
        let info = countryData.filter((time) => {
            return time.id === parseInt(id);
        });
       setCountryValue(id);
       setcountryName(info[0].country_name);
       setUserCountryCode(info[0].country_code);
    };
    const countryOptions = countryData.map(item => ({
        value: item.id,
        label: item.country_name,     // "United States"
        code: item.country_code, 
         
          country_code: item.country_code,
          dot_name: item.country_code.split("").join("."),
         updatedName: item.country_name == "United States" ? 'USA':  item.country_name
            .split(" ")
            .map(word => word.charAt(0))
            .join(""),
          updatedDotName: item.country_name == "United States" ? 'U.S.A.' : item.country_name
            .split(" ")
            .map(word => word.charAt(0))
            .join(".").concat("."),     // "US"
        }));

const timezoneOptions = timezoneData.map(item => ({
  value: item.id,
  label: item.front_name,
  name: item.name
}));
const confirmNewTimeZone = (value) => {
        let id = value;
        console.log(id, "id");
        let info = timezoneData.filter((time) => {
            return time.id === parseInt(id);
        });
        console.log(timezoneData, "timezoneData")
        console.log(info, 'timezoneData info');
        setCurrentDate(moment().tz(info[0].name).format('hh:mm A'))
        settineZonDetected(false)
        setTimeZoneName(info[0].front_name);
        setTimeZoneLocalName(info[0].name)
        setTimeZoneValue(id);
        setTimeZoneInfo(id);
        setSlotsUpdated(false);
        setActive(false);
        window.loadModal2("#CountryTimeZoneSelection", "hide");
        setShowFirstStep(false); 
       
    }
    return (
        <>

            <div className="container mt-5">

                {/* <div>
                    <div className="middle-screen-name w-100 font-size-22 mt-2 mb-2  text-center">

                        <select
                            value={timeZoneValue}
                            onChange={changeTimeZoneHandler}
                            className="select-box-timezone pointer width-440px"
                        >
                            <option disabled selected value="">
                                Change Timezone
                            </option>
                            {timezoneData.map((item) => (
                                <option value={item.id}>{item.front_name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="middle-screen-name w-100 font-size-22 mt-2 mb-2  text-center">
                        <select
                            onChange={onChangeSessionHandler}
                            className="subsession-box"
              
                        >
                            <option disabled value={""}>
                                Appoinment Type
                            </option>

                            {appointmentTyepList.map((item, index) => (
                                <option data-item={item} value={item.subsession_id}>
                                    {" "}
                                    {item.name}
                                </option>
                            ))}
                        </select>
                        <span className="d-inline-block p-2"> &nbsp;Price :${activeAmount}&nbsp;{activeCurrency}</span>
                    </div>
                </div> */}

            </div>

            <div>


                <div className="container mt-5">
                    <div>
                        {showFirstStep && (
                            <div className="container">

                                {/* Top Message */}
                                <div className="row">
                                    <div className="col-12 text-center mb-4">
                                    <h5 className="font-weight-bold">
                                        {t("bookingPage.firstStep.title")}
                                    </h5>
                                    <p className="text-muted">
                                        {t("bookingPage.firstStep.subtitle")}
                                    </p>
                                    </div>
                                </div>

                                <div className="row justify-content-center mt-3">
                                    {/* Country Dropdown */}
                                   <div className="col-12 col-md-6 mb-4">
                                    <label className="font-weight-bold">{t("bookingPage.firstStep.country")}</label>

                                  <Select
                                    className="custom-select-box"
                                     classNamePrefix="custom-select"
                                    options={countryOptions}
                                    placeholder={t("bookingPage.firstStep.chooseCountry")}
                                    value={countryOptions.find(opt => opt.value === countryValue) || null}
                                    onChange={(selected) => {
                                        const fakeEvent = { target: { value: selected.value } };
                                        changeCountry(fakeEvent);
                                    }}
                                    isSearchable={true}
                                    closeMenuOnSelect={true}
                                    filterOption={(option, inputValue) => {
                                         console.log(option, inputValue)

    if (!inputValue) return true; // Show all options if input is empty

    const label = option.label.toLowerCase();
    const input = inputValue.toLowerCase();
    const country_code = option.data.country_code.toLowerCase();
    const dot_name = option.data.dot_name.toLowerCase();
    const updatedDotName = option.data.updatedDotName.toLowerCase();
    const updatedName = option.data.updatedName.toLowerCase();

    // Match criteria: Start with, Includes, Ends with
    return label.startsWith(input)   ||
      country_code.startsWith(input) || country_code.includes(input) || country_code.endsWith(input) ||
      dot_name.startsWith(input) || dot_name.includes(input) || dot_name.endsWith(input) ||
      updatedDotName.startsWith(input) || updatedDotName.includes(input) || updatedDotName.endsWith(input) ||
      updatedName.startsWith(input) || updatedName.includes(input) || updatedName.endsWith(input)
      ;
                                    }}
                                    />
                                    </div>

                                    {/* Timezone Dropdown */}
                                   <div className="col-12 col-md-6 mb-3">
                                        <label className="font-weight-bold">{t("bookingPage.firstStep.timezone")}</label>

                                        <Select
                                            className="custom-select-box"
                                             classNamePrefix="custom-select"
                                            options={timezoneOptions}
                                            placeholder={t("bookingPage.firstStep.changeTimezone")}
                                            value={timezoneOptions.find(opt => opt.value === timeZoneValue) || null}
                                            onChange={(selected) => {
                                            const fakeEvent = {
                                                target: { value: selected.value }
                                            };
                                            changeTimeZoneHandler(fakeEvent);
                                            }}
                                            isSearchable={true}
                                            closeMenuOnSelect={true}
                                        />

                                        {tineZonDetected && (
                                            <span className="text-danger font-size-15 d-block mt-1">
                                            {t("bookingPage.firstStep.selectTimezoneError")}
                                            </span>
                                        )}
                                    </div>


                                   

                                    {/* Next Button */}
                                    <div className="col-12 text-center">
                                    <button
                                        className="resend-btn"
                                      
                                        onClick={handleNext}   // create this function for next step
                                    >
                                        {t("bookingPage.firstStep.next")}
                                    </button>
                                    </div>

                                </div>
                                </div>

                        )}
                        {!showFirstStep && (
                            <>
                             <div className="row">
                                    <div className="col-12 text-center mb-4">
                                    <h5 className="font-weight-bold">
                                       {timeZoneName !== "" ? t("bookingPage.timezoneLabel", { name: timeZoneName }) : ""}
                                    </h5>
                                    </div>
                                </div>
                        <div className="middle-screen-name w-100 font-size-22 mt-2 mb-2  text-center">
                            <select
                                onChange={onChangeSessionHandler}
                                className="subsession-box"
                                value={activeSubSessionId}
                            >
                                <option disabled value={""}>
                                    {t("bookingPage.appointmentType")}
                                </option>

                                {appointmentTyepList.map((item, index) => (
                                    <option selected={item.subsession_id === activeSubSessionId} data-item={item} value={item.subsession_id}>
                                        {" "}
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            <span className="d-inline-block p-2"> &nbsp;{t("bookingPage.price", { price: price })}&nbsp;{currency}</span>
                        </div>
                        </>
                       )}
                    </div>
                    {!showFirstStep && (
                    <h4 className='text-center'>{t("bookingPage.selectService")}</h4>
                    )}
                </div>
                <div className={`${pageType === "selection" ? 'd-none' : 'd-block'}`}>
                    <div className="p-5 m-5">

                    </div>
                    <div className="p-5 m-5">

                    </div>
                    <div className="p-5 m-5">

                    </div>
                </div>
                <div className={`${pageType === "selection" ? 'd-block' : 'd-none'}`}>
                    <div className="schedule-advance-saction">
                        <div className="container">
                            <div className="row">

                                <BookingCalendar
                                    getDatesCount={getDatesCount}
                                    timeZoneValue={timeZoneValue}
                                    dateCount={dateCount}
                                    activeSubSessionId={activeSubSessionId}
                                    getTimeSlots={getTimeSlots}
                                    slots={slots}
                                    setSlots={setSlots}
                                    setBookingDate={setBookingDate}
                                    setBookingTime={setBookingTime}
                                    slotsupdated={slotsupdated}
                                    setSlotsUpdated={setSlotsUpdated}
                                    active={active}
                                    noSlotsFound={noSlotsFound}
                                    setnoSlotsFound={setnoSlotsFound}
                                    month_empty={month_empty}
                                />
                            </div>
                        </div>
                    </div>
                    {/**********progress bar */}
                    <div className="progress-saction">
                        <div className="container">
                            <ul>
                                <li
                                    // onClick={changeRender}
                                    className="back"
                                >
                                    <Link to={'/'}>
                                        <img src="../images/black-erow.png" alt="back" />
                                        {t("bookingPage.back")}</Link>

                                </li>

                                <li className="continue">
                                    <div className="dont-have-acc">
                                        {/* sessionType==="prof"?  () =>"": */}
                                        <button
                                            onClick={handleBookingClick}
                                            type="button"
                                            className="btn btn-info btn-lg width-unset-img"
                                        // data-toggle="modal"
                                        // data-target="#myModal"
                                        >
                                            {t("bookingPage.finalizeBooking")}
                                            <img
                                                className="width-unset-img"
                                                src="../images/wight-erow.png"
                                                alt={t("bookingPage.finalizeBooking")}
                                            />
                                        </button>
                                        {/* <ConfirAdvanceModal /> */}
                                    </div>
                                </li>
                            </ul>
                        </div>

                        {/* <div style={{ width: `${loaderLine}%` }} className="prgress-baar-new">
      {loaderLine !== 0 && (
            <span className="loaderline"> {loaderLine}%</span>
          )}
      </div> */}
                    </div>
                </div>
            </div>
            <div className="dont-have-acc gust-ppop">
                <div className="modal fade" id="noslotsfound" role="dialog">
                    <div className="modal-dialog modal-dialog-preview">
                        <button
                            type="button"
                            className="close pointer"
                            data-dismiss="modal"
                        >
                            &times;
                        </button>
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="guest-popup">
                                    {/* <img src="images/sadu.png" /> */}
                                    <h3>
                                        {t("bookingPage.noSlots.line1")}
                                        <br />
                                        {t("bookingPage.noSlots.line2")}
                                        <br />
                                        {t("bookingPage.noSlots.line3")}
                                    </h3>
                                    <a
                                        data-dismiss="modal"
                                        href="javascript:void(0);"
                                    >
                                        {t("bookingPage.noSlots.cancel")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
              <TimeZoneCofirmPopup confirmRequest={confirmRequestNew} cancelRequest={cancelRequest} id={"TimeZoneCofirmPopup"} />
             <div className="text-center">
                            <TimeZonePopup newTimezoneData={timezoneData} confirmNewTimeZone={confirmNewTimeZone} disableTime={disableTime} CurrentDate={CurrentDate} />
                        </div>
             <CancellationPolicy
                          deleteUser={confirmRequest}
                          cancelRequest={cancelRequest}
                          payment_status={paymentRequest}
                          cancellation_policy={cancellationPolicy}
                          id={"ConfirmCancellationPolicy"}
                        />
                        <CountryTimeZoneSelection
                                        confirmNewTimeZone={confirmNewTimeZone}
                                        newTimezoneData={countrySpecifiedTimeZone}
                                        CurrentDate={CurrentDate}
                                        countryName={countryName}
                                    />
        </>
    );
}
